import {getCodes, getMarks, updateStrategy} from '@/request/api';
import dayjs from 'dayjs';

export default {
    fetchCodes({commit}, querys) {
        return getCodes(querys).then(response => {
            if (response.res == 0) {
                commit('setCodes', response.data);
                return true;
            } else {
                return false;
            }
        })
    },
    fetchMarks({commit}) {
        return getMarks({}).then(response => {
            if (response.res == 0) {
                commit('setMarks', response.data);
                return true;
            } else {
                return false;
            }
        })
    },
    updateStrategy({commit}, params) {
        return updateStrategy(params, {
            timeout: 2500,
            errorHandle: false
        }).then(response => {
            if (response.res == 0) {
                params.codes && commit('setCodes', params.codes.map(code => {
                    const { opType, ...nestData } = code;
                    return nestData;
                }));
                params.marks && commit('setMarks', params.marks.map(mark => {
                    const { opType, ...nestData } = mark;
                    nestData.updateTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
                    return nestData;
                }));
                return {
                    success: true,
                    msg: ''
                };
            } else {
                return {
                    success: false,
                    msg: response.msg
                };
            }
        })
    }
}